export { SeoContent } from './ui/SeoContent'
